"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parse;

var _errors = require("./errors");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function parse(_x) {
  return _parse.apply(this, arguments);
}

function _parse() {
  _parse = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(response) {
    var status, data, errorData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            status = response.status;
            data = {};
            errorData = {};
            console.info("API Response ".concat(status, " ").concat(response.url)); // HTTP 204 No content. (Nothing to deserialize).

            if (!(status === 204)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            _context.prev = 6;
            _context.next = 9;
            return response.json();

          case 9:
            data = _context.sent;
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](6);
            console.info('API response parsing failed.', _context.t0, _context.t0.stack);

          case 15:
            errorData = {
              response: response,
              data: data,
              code: status
            };

            if (!(status === 403)) {
              _context.next = 18;
              break;
            }

            throw new _errors.AuthError(errorData);

          case 18:
            if (!(status === 401)) {
              _context.next = 20;
              break;
            }

            throw new _errors.AuthError(errorData);

          case 20:
            if (!(status === 400 && data.codes === 'client_not_supported')) {
              _context.next = 22;
              break;
            }

            throw new _errors.ClientNotSupportedError(errorData);

          case 22:
            if (!(status >= 400)) {
              _context.next = 24;
              break;
            }

            throw new _errors.APIError(errorData);

          case 24:
            return _context.abrupt("return", data);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 12]]);
  }));
  return _parse.apply(this, arguments);
}